import styled from 'styled-components'

const background = '#F9F1E6'
const mainTextColor = '#2A2E3D'

export const EMVestWrapper = styled.div`
  font-family: fanngrotesque, Helvetica, Arial, sans-serif;
  color: ${mainTextColor};
  max-width: 500px;
  width: 100%;
  background: ${background};
`

export const Content = styled.main`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${background};
`

export const Heading = styled.h1`
  font-family: fanngrotesque, Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 24px;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 720px;
`
